import { Checkbox } from "antd";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Card } from "reactstrap";
import { DropdownLabel } from "../dropdown/DropdownLabel";
import { paymentStatuses, returnStatuses } from "../../data";

const SaleOrderStatuses = ({
  return_status,
  set_return_status,
  setOrderStatus,
  orderStatus,
  orderStatuses,
  setPaymentStatus,
  paymentStatus,
  orderData,
  orderCritical,
  setOrderCritical,
  orderNotes,
  setOrderNotes,
}) => {
  const location = useLocation();
  const path = location?.pathname?.split("/");
  const { user } = useSelector((state) => state.auth);
  return (
    <Card className="border-1 h-100  rounded-0 bg-light p-2  my-2 my-lg-0 billingShippingCard">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="primary-color "> Order Status</h5>
      </div>
      <div className="fs-16">
        <DropdownLabel
          customClassName={"inner_style "}
          object_key={"Order"}
          label={"Order Status"}
          listHeight={500}
          placeholder={"Select order status"}
          options={orderStatuses?.map((i) => i.label)}
          value={orderStatus ?? ""}
          showSearch
          width="100%"
          style={{ paddingLeft: "unset" }}
          onSelect={(e, value) => {
            const a = orderStatus;
            setOrderStatus(value.children);
          }}
          className={"drop_down_label_style mb-2  w-100"}
        />
        <DropdownLabel
          customClassName={"inner_style"}
          object_key={"Order"}
          label={"Payment Status"}
          placeholder={"Select Payment status"}
          options={paymentStatuses?.map((i) => i.label)}
          value={paymentStatus ?? ""}
          showSearch
          width="100%"
          style={{ paddingLeft: "unset" }}
          onSelect={(e, value) => {
            const a = paymentStatus?.value ?? paymentStatus;
            setPaymentStatus(value.children);
          }}
          className={"drop_down_label_style mb-2 w-100"}
        />
        <DropdownLabel
          customClassName={"inner_style"}
          object_key={"Order"}
          label={"Return Status"}
          placeholder={"Select Return status"}
          options={returnStatuses?.map((i) => i.label)}
          value={return_status ?? ""}
          showSearch
          width="100%"
          style={{ paddingLeft: "unset" }}
          onSelect={(e, value) => {
            const previousStatus = return_status?.value ?? return_status;
            set_return_status(value.children);
            let collection = "";
            let arrayNotes = "";
            if (path?.includes("sale-order-details")) {
              collection = "Orders";
              arrayNotes = "logs";
            } else if (path?.includes("return-order-details")) {
              collection = "ReturnOrders";
              arrayNotes = "returnOrderNotes";
            }
            if (collection && arrayNotes) {
              let obj = {
                createdAt: Date.now(),
                createdBy: user,
                message: `Return status changed from ${previousStatus} to ${value.children}`,
              };
              setOrderNotes([...orderNotes, obj]);
            }
          }}
          className={"drop_down_label_style mb-2 w-100"}
        />
        {orderData?.online && (
          <div className="d-flex align-items-center justify-content-between py-1">
            <p className="mb-0 fw-bold text-nowrap me-2" style={{ width: "130px" }}>Shipping Carrier</p>
            <p className="mb-0 primary-color text-end flex-grow-1" style={{ fontSize: "13px", fontWeight: "600" }}>
              {orderData?.shipping_carrier}
            </p>
          </div>
        )}
        {path?.includes("sale-order-details") && (
          <div className="d-flex align-items-center gap-2 mt-2">
            <Checkbox
              checked={orderCritical}
              onChange={(e) => setOrderCritical(e.target.checked)}
            />
            <p className="mb-0">Critical Order</p>
          </div>
        )}
      </div>
    </Card>
  );
};
export default SaleOrderStatuses;
